import type { Product } from '@grafikr/shopify-typescript/type/liquid/Product';
import type { variantsData } from 'types/schemas/variants-data';
import type { InferInput } from 'valibot';

import { NonNullish } from 'utils/nullish-check';

export default function getProductData(node = document.body) {
  const data = node.querySelector<HTMLScriptElement>('[data-data]');
  const variants = node.querySelector<HTMLScriptElement>('[data-variants]');

  return {
    ...(data && { product: JSON.parse(NonNullish(data.textContent)) as Product }),
    ...(variants && {
      variants: JSON.parse(NonNullish(variants.textContent)) as InferInput<typeof variantsData>,
    }),
  };
}
